import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5fdbc74f = () => interopDefault(import('../pages/accessibilita.vue' /* webpackChunkName: "pages/accessibilita" */))
const _6bc1b79a = () => interopDefault(import('../pages/acquistarecasa.vue' /* webpackChunkName: "pages/acquistarecasa" */))
const _1b3d77d4 = () => interopDefault(import('../pages/cartadeiservizi.vue' /* webpackChunkName: "pages/cartadeiservizi" */))
const _e5a60026 = () => interopDefault(import('../pages/catalogo.vue' /* webpackChunkName: "pages/catalogo" */))
const _7b182480 = () => interopDefault(import('../pages/chisiamo.vue' /* webpackChunkName: "pages/chisiamo" */))
const _6780f130 = () => interopDefault(import('../pages/come-vendere-casa.vue' /* webpackChunkName: "pages/come-vendere-casa" */))
const _853785c0 = () => interopDefault(import('../pages/consigli-vendere-casa.vue' /* webpackChunkName: "pages/consigli-vendere-casa" */))
const _bde8d0d2 = () => interopDefault(import('../pages/contatto.vue' /* webpackChunkName: "pages/contatto" */))
const _636b07ee = () => interopDefault(import('../pages/datisocietari.vue' /* webpackChunkName: "pages/datisocietari" */))
const _15b47bd2 = () => interopDefault(import('../pages/disclaimer.vue' /* webpackChunkName: "pages/disclaimer" */))
const _4ca8c739 = () => interopDefault(import('../pages/documenti-necessari.vue' /* webpackChunkName: "pages/documenti-necessari" */))
const _1b2c83bc = () => interopDefault(import('../pages/fai-le-tue-scelte-cookie.vue' /* webpackChunkName: "pages/fai-le-tue-scelte-cookie" */))
const _6fcfcab2 = () => interopDefault(import('../pages/fascicolocasa.vue' /* webpackChunkName: "pages/fascicolocasa" */))
const _64e08264 = () => interopDefault(import('../pages/informativacookies.vue' /* webpackChunkName: "pages/informativacookies" */))
const _797a1153 = () => interopDefault(import('../pages/modelloorganizzazione.vue' /* webpackChunkName: "pages/modelloorganizzazione" */))
const _33a9df4d = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _e0a7b4ae = () => interopDefault(import('../pages/perche-vendere-casa.vue' /* webpackChunkName: "pages/perche-vendere-casa" */))
const _7e821f24 = () => interopDefault(import('../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _6aac59bc = () => interopDefault(import('../pages/proprieta-arianna.vue' /* webpackChunkName: "pages/proprieta-arianna" */))
const _222a49b8 = () => interopDefault(import('../pages/scopri-app-plus.vue' /* webpackChunkName: "pages/scopri-app-plus" */))
const _55a82282 = () => interopDefault(import('../pages/scopri-area-riservata.vue' /* webpackChunkName: "pages/scopri-area-riservata" */))
const _54356848 = () => interopDefault(import('../pages/semplicita-e-trasparenza.vue' /* webpackChunkName: "pages/semplicita-e-trasparenza" */))
const _fd38034a = () => interopDefault(import('../pages/servizi.vue' /* webpackChunkName: "pages/servizi" */))
const _2daf90cd = () => interopDefault(import('../pages/servizi-documenti-casa.vue' /* webpackChunkName: "pages/servizi-documenti-casa" */))
const _1d47581e = () => interopDefault(import('../pages/valuta-casa.vue' /* webpackChunkName: "pages/valuta-casa" */))
const _315a74fa = () => interopDefault(import('../pages/vendo.vue' /* webpackChunkName: "pages/vendo" */))
const _1ecf4b20 = () => interopDefault(import('../pages/area-riservata/annunci-nascosti.vue' /* webpackChunkName: "pages/area-riservata/annunci-nascosti" */))
const _4fdd022c = () => interopDefault(import('../pages/area-riservata/annunci-preferiti.vue' /* webpackChunkName: "pages/area-riservata/annunci-preferiti" */))
const _351539aa = () => interopDefault(import('../pages/area-riservata/annunci-preferiti-mappa.vue' /* webpackChunkName: "pages/area-riservata/annunci-preferiti-mappa" */))
const _207397dd = () => interopDefault(import('../pages/area-riservata/dashboard.vue' /* webpackChunkName: "pages/area-riservata/dashboard" */))
const _562e2ab2 = () => interopDefault(import('../pages/area-riservata/login.vue' /* webpackChunkName: "pages/area-riservata/login" */))
const _86af97de = () => interopDefault(import('../pages/area-riservata/logout.vue' /* webpackChunkName: "pages/area-riservata/logout" */))
const _d28f6aee = () => interopDefault(import('../pages/area-riservata/modifica-password.vue' /* webpackChunkName: "pages/area-riservata/modifica-password" */))
const _592bd535 = () => interopDefault(import('../pages/area-riservata/modifica-profilo.vue' /* webpackChunkName: "pages/area-riservata/modifica-profilo" */))
const _bde862e0 = () => interopDefault(import('../pages/area-riservata/notifiche.vue' /* webpackChunkName: "pages/area-riservata/notifiche" */))
const _4accabe2 = () => interopDefault(import('../pages/area-riservata/otp-verify.vue' /* webpackChunkName: "pages/area-riservata/otp-verify" */))
const _4beb1f3e = () => interopDefault(import('../pages/area-riservata/registrati.vue' /* webpackChunkName: "pages/area-riservata/registrati" */))
const _1b062bca = () => interopDefault(import('../pages/area-riservata/reset/index.vue' /* webpackChunkName: "pages/area-riservata/reset/index" */))
const _4e2b697b = () => interopDefault(import('../pages/area-riservata/ricerche-salvate.vue' /* webpackChunkName: "pages/area-riservata/ricerche-salvate" */))
const _52b59dac = () => interopDefault(import('../pages/area-riservata/rinnova-password.vue' /* webpackChunkName: "pages/area-riservata/rinnova-password" */))
const _741eade0 = () => interopDefault(import('../pages/area-riservata/servizi-documenti-casa/index.vue' /* webpackChunkName: "pages/area-riservata/servizi-documenti-casa/index" */))
const _2feb63ba = () => interopDefault(import('../pages/impersonate/leave.vue' /* webpackChunkName: "pages/impersonate/leave" */))
const _199aef1a = () => interopDefault(import('../pages/privacy/informativa-per-la-clientela.vue' /* webpackChunkName: "pages/privacy/informativa-per-la-clientela" */))
const _15256cfa = () => interopDefault(import('../pages/privacy/informativa-relativa-sito-web.vue' /* webpackChunkName: "pages/privacy/informativa-relativa-sito-web" */))
const _c9771732 = () => interopDefault(import('../pages/area-riservata/registrazione-veloce/modifica-password.vue' /* webpackChunkName: "pages/area-riservata/registrazione-veloce/modifica-password" */))
const _100ddc2a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4ca14ad4 = () => interopDefault(import('../pages/area-riservata/annunci/_id.vue' /* webpackChunkName: "pages/area-riservata/annunci/_id" */))
const _3a301dfe = () => interopDefault(import('../pages/area-riservata/reset/_token.vue' /* webpackChunkName: "pages/area-riservata/reset/_token" */))
const _53be752e = () => interopDefault(import('../pages/area-riservata/servizi-documenti-casa/_category/index.vue' /* webpackChunkName: "pages/area-riservata/servizi-documenti-casa/_category/index" */))
const _2d33cfff = () => interopDefault(import('../pages/impersonate/take/_id.vue' /* webpackChunkName: "pages/impersonate/take/_id" */))
const _08e26050 = () => interopDefault(import('../pages/news/tag/_slug.vue' /* webpackChunkName: "pages/news/tag/_slug" */))
const _033cf345 = () => interopDefault(import('../pages/area-riservata/registrazione-verifica/_id/_token.vue' /* webpackChunkName: "pages/area-riservata/registrazione-verifica/_id/_token" */))
const _3359eef2 = () => interopDefault(import('../pages/area-riservata/servizi-documenti-casa/_category/_product/index.vue' /* webpackChunkName: "pages/area-riservata/servizi-documenti-casa/_category/_product/index" */))
const _4091e537 = () => interopDefault(import('../pages/area-riservata/servizi-documenti-casa/_category/_product/redirect.vue' /* webpackChunkName: "pages/area-riservata/servizi-documenti-casa/_category/_product/redirect" */))
const _7e76d924 = () => interopDefault(import('../pages/annunci/_id.vue' /* webpackChunkName: "pages/annunci/_id" */))
const _e5befb4a = () => interopDefault(import('../pages/news/_category/index.vue' /* webpackChunkName: "pages/news/_category/index" */))
const _e92c3dda = () => interopDefault(import('../pages/news/_category/_slug.vue' /* webpackChunkName: "pages/news/_category/_slug" */))
const _4e54f1ae = () => interopDefault(import('../pages/-listing.vue' /* webpackChunkName: "" */))
const _0326099b = () => interopDefault(import('../pages/-property.vue' /* webpackChunkName: "" */))
const _4363dd9c = () => interopDefault(import('../pages/-sell-geo.vue' /* webpackChunkName: "" */))
const _73b5a755 = () => interopDefault(import('../pages/-sell-campaign.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'ucrs-active-link',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accessibilita",
    component: _5fdbc74f,
    name: "accessibilita"
  }, {
    path: "/acquistarecasa",
    component: _6bc1b79a,
    name: "acquistarecasa"
  }, {
    path: "/cartadeiservizi",
    component: _1b3d77d4,
    name: "cartadeiservizi"
  }, {
    path: "/catalogo",
    component: _e5a60026,
    name: "catalogo"
  }, {
    path: "/chisiamo",
    component: _7b182480,
    name: "chisiamo"
  }, {
    path: "/come-vendere-casa",
    component: _6780f130,
    name: "come-vendere-casa"
  }, {
    path: "/consigli-vendere-casa",
    component: _853785c0,
    name: "consigli-vendere-casa"
  }, {
    path: "/contatto",
    component: _bde8d0d2,
    name: "contatto"
  }, {
    path: "/datisocietari",
    component: _636b07ee,
    name: "datisocietari"
  }, {
    path: "/disclaimer",
    component: _15b47bd2,
    name: "disclaimer"
  }, {
    path: "/documenti-necessari",
    component: _4ca8c739,
    name: "documenti-necessari"
  }, {
    path: "/fai-le-tue-scelte-cookie",
    component: _1b2c83bc,
    name: "fai-le-tue-scelte-cookie"
  }, {
    path: "/fascicolocasa",
    component: _6fcfcab2,
    name: "fascicolocasa"
  }, {
    path: "/informativacookies",
    component: _64e08264,
    name: "informativacookies"
  }, {
    path: "/modelloorganizzazione",
    component: _797a1153,
    name: "modelloorganizzazione"
  }, {
    path: "/news",
    component: _33a9df4d,
    name: "news"
  }, {
    path: "/perche-vendere-casa",
    component: _e0a7b4ae,
    name: "perche-vendere-casa"
  }, {
    path: "/privacy",
    component: _7e821f24,
    name: "privacy"
  }, {
    path: "/proprieta-arianna",
    component: _6aac59bc,
    name: "proprieta-arianna"
  }, {
    path: "/scopri-app-plus",
    component: _222a49b8,
    name: "scopri-app-plus"
  }, {
    path: "/scopri-area-riservata",
    component: _55a82282,
    name: "scopri-area-riservata"
  }, {
    path: "/semplicita-e-trasparenza",
    component: _54356848,
    name: "semplicita-e-trasparenza"
  }, {
    path: "/servizi",
    component: _fd38034a,
    name: "servizi"
  }, {
    path: "/servizi-documenti-casa",
    component: _2daf90cd,
    name: "servizi-documenti-casa"
  }, {
    path: "/valuta-casa",
    component: _1d47581e,
    name: "valuta-casa"
  }, {
    path: "/vendo",
    component: _315a74fa,
    name: "vendo"
  }, {
    path: "/area-riservata/annunci-nascosti",
    component: _1ecf4b20,
    name: "area-riservata-annunci-nascosti"
  }, {
    path: "/area-riservata/annunci-preferiti",
    component: _4fdd022c,
    name: "area-riservata-annunci-preferiti"
  }, {
    path: "/area-riservata/annunci-preferiti-mappa",
    component: _351539aa,
    name: "area-riservata-annunci-preferiti-mappa"
  }, {
    path: "/area-riservata/dashboard",
    component: _207397dd,
    name: "area-riservata-dashboard"
  }, {
    path: "/area-riservata/login",
    component: _562e2ab2,
    name: "area-riservata-login"
  }, {
    path: "/area-riservata/logout",
    component: _86af97de,
    name: "area-riservata-logout"
  }, {
    path: "/area-riservata/modifica-password",
    component: _d28f6aee,
    name: "area-riservata-modifica-password"
  }, {
    path: "/area-riservata/modifica-profilo",
    component: _592bd535,
    name: "area-riservata-modifica-profilo"
  }, {
    path: "/area-riservata/notifiche",
    component: _bde862e0,
    name: "area-riservata-notifiche"
  }, {
    path: "/area-riservata/otp-verify",
    component: _4accabe2,
    name: "area-riservata-otp-verify"
  }, {
    path: "/area-riservata/registrati",
    component: _4beb1f3e,
    name: "area-riservata-registrati"
  }, {
    path: "/area-riservata/reset",
    component: _1b062bca,
    name: "area-riservata-reset"
  }, {
    path: "/area-riservata/ricerche-salvate",
    component: _4e2b697b,
    name: "area-riservata-ricerche-salvate"
  }, {
    path: "/area-riservata/rinnova-password",
    component: _52b59dac,
    name: "area-riservata-rinnova-password"
  }, {
    path: "/area-riservata/servizi-documenti-casa",
    component: _741eade0,
    name: "area-riservata-servizi-documenti-casa"
  }, {
    path: "/impersonate/leave",
    component: _2feb63ba,
    name: "impersonate-leave"
  }, {
    path: "/privacy/informativa-per-la-clientela",
    component: _199aef1a,
    name: "privacy-informativa-per-la-clientela"
  }, {
    path: "/privacy/informativa-relativa-sito-web",
    component: _15256cfa,
    name: "privacy-informativa-relativa-sito-web"
  }, {
    path: "/area-riservata/registrazione-veloce/modifica-password",
    component: _c9771732,
    name: "area-riservata-registrazione-veloce-modifica-password"
  }, {
    path: "/",
    component: _100ddc2a,
    name: "index"
  }, {
    path: "/area-riservata/annunci/:id?",
    component: _4ca14ad4,
    name: "area-riservata-annunci-id"
  }, {
    path: "/area-riservata/reset/:token?",
    component: _3a301dfe,
    name: "area-riservata-reset-token"
  }, {
    path: "/area-riservata/servizi-documenti-casa/:category",
    component: _53be752e,
    name: "area-riservata-servizi-documenti-casa-category"
  }, {
    path: "/impersonate/take/:id?",
    component: _2d33cfff,
    name: "impersonate-take-id"
  }, {
    path: "/news/tag/:slug?",
    component: _08e26050,
    name: "news-tag-slug"
  }, {
    path: "/area-riservata/registrazione-verifica/:id?/:token?",
    component: _033cf345,
    name: "area-riservata-registrazione-verifica-id-token"
  }, {
    path: "/area-riservata/servizi-documenti-casa/:category?/:product",
    component: _3359eef2,
    name: "area-riservata-servizi-documenti-casa-category-product"
  }, {
    path: "/area-riservata/servizi-documenti-casa/:category?/:product?/redirect",
    component: _4091e537,
    name: "area-riservata-servizi-documenti-casa-category-product-redirect"
  }, {
    path: "/annunci/:id?",
    component: _7e76d924,
    name: "annunci-id"
  }, {
    path: "/news/:category",
    component: _e5befb4a,
    name: "news-category"
  }, {
    path: "/news/:category/:slug",
    component: _e92c3dda,
    name: "news-category-slug"
  }, {
    path: "/:section(venditaimmobili|nuovecostruzioni|immobilicommerciali|immobilidipregio|proprieta-unicredit)",
    component: _4e54f1ae,
    name: "listing-showcase"
  }, {
    path: "/:section(venditaimmobili|nuovecostruzioni|immobilicommerciali|immobilidipregio|proprieta-unicredit)/:province([a-z]{2})/:typology(appartamento|attico|villa|villa-a-schiera|villa-unifamiliare|villa-bifamiliare|villa-trifamiliare|villa-quadrifamiliare|villetta|mansarda|loft|immobile-di-prestigio|stabile-palazzo|casa-indipendente|porzione-di-casa|rustico|casa-colonica|casale|terratetto-terracielo|ufficio|studio|locale-commerciale|capannone|laboratorio|magazzino|deposito|attivita-commerciale|negozio|bar-tabacchi-ricevitoria|generi-monopolio-giochi|ristorante|bar-tavola-calda-fredda|enoteca-wine-bar|pasticceria-gelateria|discoteca-disco-pub-locale-notturno|alimentari-gastronomia|frutta-e-verdura|macelleria-salumeria|panificio-pastificio|pescheria|supermercato-minimarket|carrozzeria-officina-elettrauto|autolavaggio|concessionario|ricambi-e-accessori|garage-autosilos-parcheggio|gommista|audio-video|computer-informatica|sala-giochi|musica-e-strumenti|videoteca-videogames|telefonia-cellulari-elettrodomestici|internet-point-phone-center|hotel|agenzia-viaggi-e-turismo|bed-and-breakfast|articoli-sportivi|abbigliamento-intimo|calzature-pelletteria-valigeria|gioielleria-bijoutteria-orologeria|merceria|centro-estetico-solarium-benessere|profumeria-e-cosmetica|parrucchieri-uomo-donna|palestra-e-impianti-sportivi|articoli-caccia-e-pesca|colorificio-ferramenta-elettricita|edicola-edicola-con-chiosco|farmacia-erboristeria|piante-e-fiori|foto-ottica|giocattoli-gadget|impresa-pulizia|lavanderia-tintoria|cartoleria-libreria|materiali-e-prodotti-edilizi|mobili-arredanento|articoli-da-regalo-casalinghi|idraulica-elettricita|riparazioni-fai-da-te|tempo-libero|agenzia-intermediazioni-immobiliari|agenzia-intermediazioni-creditizie|trullo|dammuso|nuraghe|maso|baglio|rifugio|sasso|baita|agriturismo|residence|multiproprieta|bungalow|terreno-agricolo|terreno-residenziale|terreno-commerciale|box|posto-auto|posto-moto|cascina|show-room|pensione|ostello|relais|hotel-di-lusso|campeggio|stabilimento-balneare|terreno-industriale|terreno-artigianale-terziario|terreno-turistico|stanza-camera|posto-barca|posto-camper-roulotte|auto-silos|castello|dimora-storica|torre|palazzo-storico|villa-storica|convento-monastero|centralina|consorzio-agrario|filiale-bancaria|scuderia|struttura-ricettiva|struttura-commerciale|stabile|palazzo|terratetto|terracielo|bar|tabacchi|ricevitoria|enoteca|wine-bar|pasticceria|gelateri|discoteca|disco-pub|locale-notturno|alimentari|gastronomia|macelleria|salumeria|panificio|pastificio|supermercato|minimarket|carrozzeria|officina|elettrauto|ricambi|accessori|garage|autosilos|parcheggio|computer|informatica|musica|strumenti|videoteca|videogames|telefonia|cellulari|elettrodomestici|internet-point|phone-center|agenzia-viaggi|abbigliamento|intimo|calzature|pelletteria|valigeria|gioielleria|bijoutteria|orologeria|centro-estetico|solarium|benessere|profumeria|parrucchiere|palestra|impianto-sportivo|caccia-e-pesca|colorificio|ferramenta|elettricita|edicola|farmacia|giocattoli|lavanderia|tintoria|cartoleria|Libreria|materiali-edilizi|prodotti-edilizi|mobili|arredamento|articoli-regalo|casalinghi|idraulica|riparazioni|fai-da-te|agenzia-immobiliare)?/:subtypology(monolocale|bilocale|trilocale|oltre3locali)?/:pag(pag-[0-9]+)?",
    component: _4e54f1ae,
    name: "listing-no-city"
  }, {
    path: "/:section(venditaimmobili|nuovecostruzioni|immobilicommerciali|immobilidipregio|proprieta-unicredit)/:province([a-z]{2})/:city([a-z-]+)?/:typology(appartamento|attico|villa|villa-a-schiera|villa-unifamiliare|villa-bifamiliare|villa-trifamiliare|villa-quadrifamiliare|villetta|mansarda|loft|immobile-di-prestigio|stabile-palazzo|casa-indipendente|porzione-di-casa|rustico|casa-colonica|casale|terratetto-terracielo|ufficio|studio|locale-commerciale|capannone|laboratorio|magazzino|deposito|attivita-commerciale|negozio|bar-tabacchi-ricevitoria|generi-monopolio-giochi|ristorante|bar-tavola-calda-fredda|enoteca-wine-bar|pasticceria-gelateria|discoteca-disco-pub-locale-notturno|alimentari-gastronomia|frutta-e-verdura|macelleria-salumeria|panificio-pastificio|pescheria|supermercato-minimarket|carrozzeria-officina-elettrauto|autolavaggio|concessionario|ricambi-e-accessori|garage-autosilos-parcheggio|gommista|audio-video|computer-informatica|sala-giochi|musica-e-strumenti|videoteca-videogames|telefonia-cellulari-elettrodomestici|internet-point-phone-center|hotel|agenzia-viaggi-e-turismo|bed-and-breakfast|articoli-sportivi|abbigliamento-intimo|calzature-pelletteria-valigeria|gioielleria-bijoutteria-orologeria|merceria|centro-estetico-solarium-benessere|profumeria-e-cosmetica|parrucchieri-uomo-donna|palestra-e-impianti-sportivi|articoli-caccia-e-pesca|colorificio-ferramenta-elettricita|edicola-edicola-con-chiosco|farmacia-erboristeria|piante-e-fiori|foto-ottica|giocattoli-gadget|impresa-pulizia|lavanderia-tintoria|cartoleria-libreria|materiali-e-prodotti-edilizi|mobili-arredanento|articoli-da-regalo-casalinghi|idraulica-elettricita|riparazioni-fai-da-te|tempo-libero|agenzia-intermediazioni-immobiliari|agenzia-intermediazioni-creditizie|trullo|dammuso|nuraghe|maso|baglio|rifugio|sasso|baita|agriturismo|residence|multiproprieta|bungalow|terreno-agricolo|terreno-residenziale|terreno-commerciale|box|posto-auto|posto-moto|cascina|show-room|pensione|ostello|relais|hotel-di-lusso|campeggio|stabilimento-balneare|terreno-industriale|terreno-artigianale-terziario|terreno-turistico|stanza-camera|posto-barca|posto-camper-roulotte|auto-silos|castello|dimora-storica|torre|palazzo-storico|villa-storica|convento-monastero|centralina|consorzio-agrario|filiale-bancaria|scuderia|struttura-ricettiva|struttura-commerciale|stabile|palazzo|terratetto|terracielo|bar|tabacchi|ricevitoria|enoteca|wine-bar|pasticceria|gelateri|discoteca|disco-pub|locale-notturno|alimentari|gastronomia|macelleria|salumeria|panificio|pastificio|supermercato|minimarket|carrozzeria|officina|elettrauto|ricambi|accessori|garage|autosilos|parcheggio|computer|informatica|musica|strumenti|videoteca|videogames|telefonia|cellulari|elettrodomestici|internet-point|phone-center|agenzia-viaggi|abbigliamento|intimo|calzature|pelletteria|valigeria|gioielleria|bijoutteria|orologeria|centro-estetico|solarium|benessere|profumeria|parrucchiere|palestra|impianto-sportivo|caccia-e-pesca|colorificio|ferramenta|elettricita|edicola|farmacia|giocattoli|lavanderia|tintoria|cartoleria|Libreria|materiali-edilizi|prodotti-edilizi|mobili|arredamento|articoli-regalo|casalinghi|idraulica|riparazioni|fai-da-te|agenzia-immobiliare)?/:subtypology(monolocale|bilocale|trilocale|oltre3locali)?/:pag(pag-[0-9]+)?",
    component: _4e54f1ae,
    name: "listing-no-zone"
  }, {
    path: "/:section(venditaimmobili|nuovecostruzioni|immobilicommerciali|immobilidipregio|proprieta-unicredit)/:province([a-z]{2})/:city([a-z-]+)?/:zone([a-z-]+)?/:typology(appartamento|attico|villa|villa-a-schiera|villa-unifamiliare|villa-bifamiliare|villa-trifamiliare|villa-quadrifamiliare|villetta|mansarda|loft|immobile-di-prestigio|stabile-palazzo|casa-indipendente|porzione-di-casa|rustico|casa-colonica|casale|terratetto-terracielo|ufficio|studio|locale-commerciale|capannone|laboratorio|magazzino|deposito|attivita-commerciale|negozio|bar-tabacchi-ricevitoria|generi-monopolio-giochi|ristorante|bar-tavola-calda-fredda|enoteca-wine-bar|pasticceria-gelateria|discoteca-disco-pub-locale-notturno|alimentari-gastronomia|frutta-e-verdura|macelleria-salumeria|panificio-pastificio|pescheria|supermercato-minimarket|carrozzeria-officina-elettrauto|autolavaggio|concessionario|ricambi-e-accessori|garage-autosilos-parcheggio|gommista|audio-video|computer-informatica|sala-giochi|musica-e-strumenti|videoteca-videogames|telefonia-cellulari-elettrodomestici|internet-point-phone-center|hotel|agenzia-viaggi-e-turismo|bed-and-breakfast|articoli-sportivi|abbigliamento-intimo|calzature-pelletteria-valigeria|gioielleria-bijoutteria-orologeria|merceria|centro-estetico-solarium-benessere|profumeria-e-cosmetica|parrucchieri-uomo-donna|palestra-e-impianti-sportivi|articoli-caccia-e-pesca|colorificio-ferramenta-elettricita|edicola-edicola-con-chiosco|farmacia-erboristeria|piante-e-fiori|foto-ottica|giocattoli-gadget|impresa-pulizia|lavanderia-tintoria|cartoleria-libreria|materiali-e-prodotti-edilizi|mobili-arredanento|articoli-da-regalo-casalinghi|idraulica-elettricita|riparazioni-fai-da-te|tempo-libero|agenzia-intermediazioni-immobiliari|agenzia-intermediazioni-creditizie|trullo|dammuso|nuraghe|maso|baglio|rifugio|sasso|baita|agriturismo|residence|multiproprieta|bungalow|terreno-agricolo|terreno-residenziale|terreno-commerciale|box|posto-auto|posto-moto|cascina|show-room|pensione|ostello|relais|hotel-di-lusso|campeggio|stabilimento-balneare|terreno-industriale|terreno-artigianale-terziario|terreno-turistico|stanza-camera|posto-barca|posto-camper-roulotte|auto-silos|castello|dimora-storica|torre|palazzo-storico|villa-storica|convento-monastero|centralina|consorzio-agrario|filiale-bancaria|scuderia|struttura-ricettiva|struttura-commerciale|stabile|palazzo|terratetto|terracielo|bar|tabacchi|ricevitoria|enoteca|wine-bar|pasticceria|gelateri|discoteca|disco-pub|locale-notturno|alimentari|gastronomia|macelleria|salumeria|panificio|pastificio|supermercato|minimarket|carrozzeria|officina|elettrauto|ricambi|accessori|garage|autosilos|parcheggio|computer|informatica|musica|strumenti|videoteca|videogames|telefonia|cellulari|elettrodomestici|internet-point|phone-center|agenzia-viaggi|abbigliamento|intimo|calzature|pelletteria|valigeria|gioielleria|bijoutteria|orologeria|centro-estetico|solarium|benessere|profumeria|parrucchiere|palestra|impianto-sportivo|caccia-e-pesca|colorificio|ferramenta|elettricita|edicola|farmacia|giocattoli|lavanderia|tintoria|cartoleria|Libreria|materiali-edilizi|prodotti-edilizi|mobili|arredamento|articoli-regalo|casalinghi|idraulica|riparazioni|fai-da-te|agenzia-immobiliare)?/:subtypology(monolocale|bilocale|trilocale|oltre3locali)?/:pag(pag-[0-9]+)?",
    component: _4e54f1ae,
    name: "listing"
  }, {
    path: "/:section(venditaimmobili|nuovecostruzioni|immobilicommerciali|immobilidipregio|proprieta-unicredit)/:province([a-z]{2})/:city([a-z-]+)/:slug([A-Za-z0-9-]+)-:idprefix(ID[C]?):id([GBP0-9]+)",
    component: _0326099b,
    name: "property"
  }, {
    path: "/vendo/vendere-casa-:slug",
    component: _4363dd9c,
    name: "sell-geo"
  }, {
    path: "/vendo/:slug",
    component: _73b5a755,
    name: "sell-campaign"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
